import css from './index.module.scss';
import { useGlobal } from '@/utils/useGlobal';

export default function C({ tags }: any) {
    const { useLang, gtm } = useGlobal();
    const { t } = useLang('vanliferoadtrips');
    return (
        <div id="vanlife-roadtrips-C" className={`vanlife-roadtrips-C ${css['vanlife-roadtrips-C']}`}>
            <div className="ef-box">
                <div className="text-box">
                    <p className="title">{t('secC_title')}</p>
                </div>
                <div className="tags">
                    {tags?.map((tag: any, k: number) => (
                        <a
                            className="tag"
                            href={tag?.link}
                            key={k}
                            onClick={() =>
                                gtm.push({
                                    event: 'uaEvent',
                                    event_name: 'tab_click',
                                    button_name: tag?.text,
                                    list_name: t('secC_title'),
                                })
                            }
                        >
                            {tag?.text}
                        </a>
                    ))}
                </div>
            </div>
        </div>
    );
}
